import { render, staticRenderFns } from "./newReceiverControl.vue?vue&type=template&id=47591793&scoped=true"
import script from "./newReceiverControl.vue?vue&type=script&lang=js"
export * from "./newReceiverControl.vue?vue&type=script&lang=js"
import style0 from "./newReceiverControl.vue?vue&type=style&index=0&id=47591793&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47591793",
  null
  
)

export default component.exports